import styled from 'styled-components';
import { colors, device } from '../../styles/stylesheets';


export const BannerWhats = styled.div`
  border-radius: 8px;
  background: #455A64;
  padding: 20px 40px;
  margin-top: 15px;
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 3fr 1fr;
  width: 100%;
  color: ${colors.white};

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 0.5fr;
  }

  div {
    margin-right: 15px;

    @media (max-width: 680px) {
       justify-content: center;
    }

    h2 {
      font-weight: 500;
      font-size: 20px;
      line-height: 32px;
      margin: 16px 0;
      font-weight: 600;
      text-align: center;
    }

    p {
      font-size: 14px;
      line-height: 20px;
      
      @media (max-width: 680px) {
        text-align: center;
      }
    }
  }
`;

export const ImgStyled = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 8px;
`;

export const HeaderModal = styled.div`
  display: grid;
  width: 100%;
  height: 40px;
  grid-template-columns: 1fr 30px;
  align-items: center;
  justify-items: center;
  h3 {
    text-align: center;
  }
`;

export const Subtitle = styled.h3`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
`;

export const ContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  position:relative;
  flex: 1;
  align-items: center;
  overflow-y: auto;
  padding: 0 40px;
  margin-top: 40px;
`;

export const ContentImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  background: #455A64;
  border-radius: 8px;

  margin: 24px 0;
`;

export const StyledBoldText = styled.b`
   font-weight: 500;
`;

export const ContextText = styled.p`
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
`;
